import React, { Suspense, lazy } from 'react'
import { SharePointRouteGate } from './SharePointRouteGate'

// Lazy so MSAL and the Graph client only download when the portal is opened.
const SharePointPortal = lazy(() => import('./SharePointPortal'))

export default function SharePoint() {
  return (
    <SharePointRouteGate>
      <Suspense fallback={null}>
        <SharePointPortal />
      </Suspense>
    </SharePointRouteGate>
  )
}
